import React from 'react';
import '../styles.css';
import Preview from 'preview-office-docs';

const MsViewer = ({ url }) =>
{

	return (
		<div className='flexCol FileWidth80 mrgnHAuto alignCntr fullH'>
			<div className='flexRow  justifyCntr fullH msPreview'>
				<Preview url={url} />
			</div>
		</div>
	);
};

export default MsViewer;